import React from "react"

import Grid from "./grid"
import ContactForm from "./contact.form"
import { SubHeading, Title, Disclaimer } from "./contact.style"

const Contact = () => {
  return (
    <Grid id="contact-form" addMargin={false}>
      <SubHeading name="contact-form">Ready To Get Started?</SubHeading>
      <Title>Contact Us Today</Title>
      <ContactForm />
      <Disclaimer>
        Mappedin needs the contact information you provide to us to contact you
        about our products and services. You may unsubscribe from these
        communications at any time. For information on how to unsubscribe, as
        well as our privacy practices and commitment to protecting your privacy,
        please review our Privacy Policy.
      </Disclaimer>
    </Grid>
  )
}

export default Contact
